//@flow
import React from 'react';
import type { JobPost } from 'types/careers';
import RecommendedMobileCarousel from 'components/organisms/recommendedMobileCarousel';
import './styles.scss';

type Props = {
  jobPosts: Array<JobPost>,
  onClick: () => void,
};

export const JobPostsMobile = (props: Props) => {
  const { jobPosts, onClick, breadcrumbList } = props;

  return (
    <RecommendedMobileCarousel
      recommendedList={jobPosts}
      fetchTitle={
        <div className={'text-container'}>
          <h1 className={'section-heading'}>Join Our Team</h1>
          <h4 className={'short-description'}>
            Lorem Ipsum is a dummy text used as a placeholder, mostly for
            developing a website.
          </h4>
        </div>
      }
      isDisplayLocationIcon={false}
      displayDistance={true}
      displayFullArea={true}
      isDefinedRoute={true}
      type="career"
      onClick={onClick}
      breadcrumbList={breadcrumbList}
    />
  );
};
